import { NgModule } from '@angular/core';
import { HpDatasetsPanelComponent } from './hp-datasets.component';
import { CommonModule } from '@angular/common';
import { DevExtremeModule } from '../devextreme.module';

@NgModule({
  imports: [
    CommonModule,
    DevExtremeModule
  ],
  exports: [HpDatasetsPanelComponent],
  declarations: [HpDatasetsPanelComponent],
  providers: [],
})
export class EtsHpDatasetsModule { }
